const PrivacyPolicy: React.FC = () => {
  const styles = {
    bodyBackground: {
      backgroundColor: "#f4f7f6",
      padding: "40px 20px",
      minHeight: "100vh",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      lineHeight: "1.7",
      color: "#2c3e50",
    },
    policyContainer: {
      background: "#ffffff",
      maxWidth: "850px",
      margin: "0 auto",
      padding: "50px 60px",
      borderRadius: "12px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
      border: "1px solid #eef2f5",
    },
    headerBar: {
      borderLeft: "5px solid #1a73e8",
      paddingLeft: "20px",
      marginBottom: "40px",
    },
    h1: {
      color: "#1a73e8",
      fontSize: "2.2rem",
      margin: "0 0 10px 0",
      fontWeight: "700",
      letterSpacing: "-0.5px",
    },
    metaDate: {
      fontSize: "0.95rem",
      color: "#7f8c8d",
      margin: "0",
    },
    h2: {
      color: "#2c3e50",
      fontSize: "1.35rem",
      marginTop: "35px",
      marginBottom: "15px",
      fontWeight: "600",
      borderBottom: "1px solid #f0f4f8",
      paddingBottom: "8px",
    },
    p: {
      marginTop: "0",
      marginBottom: "1.25rem",
      color: "#4a5568",
    },
    ul: {
      marginTop: "0",
      marginBottom: "1.5rem",
      paddingLeft: "24px",
    },
    li: {
      marginBottom: "0.5rem",
      color: "#4a5568",
    },
    contactBox: {
      backgroundColor: "#f8fafc",
      border: "1px solid #e2e8f0",
      borderRadius: "8px",
      padding: "20px",
      marginTop: "40px",
    },
    link: {
      color: "#1a73e8",
      textDecoration: "none",
      fontWeight: "500",
    },
    footer: {
      marginTop: "50px",
      fontSize: "0.85rem",
      color: "#a0aec0",
      textAlign: "center",
      borderTop: "1px solid #edf2f7",
      paddingTop: "25px",
    },
  };

  return (
    <div style={styles.bodyBackground}>
      <div style={styles.policyContainer}>
        <div style={styles.headerBar}>
          <h1 style={styles.h1}>Privacy Policy</h1>
          <p style={styles.metaDate}>
            <strong>Effective Date:</strong> May 20, 2026
          </p>
        </div>

        <p style={styles.p}>
          This Privacy Policy explains how <strong>OnlyRyan</strong> ("we",
          "us", or "our") collects, uses, and protects your information when you
          use our mobile application (the "App").
        </p>
        <p style={styles.p}>
          We are fully committed to protecting your personal privacy and
          providing a safe, secure environment for our users. This policy
          ensures strict alignment with Google Play Store Developer Policies and
          applicable data privacy guidelines.
        </p>

        <h2 style={styles.h2}>1. Information We Collect</h2>
        <p style={styles.p}>
          We collect specific types of information to provide you with a
          functional, optimized, and personalized quiz experience:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            <strong>Personal Information:</strong> Information you provide
            explicitly when creating an account, such as your name, username,
            and email address.
          </li>
          <li style={styles.li}>
            <strong>Usage Data:</strong> Analytical details about how you
            interact with the App, including your quiz scores, progress
            tracking, gameplay statistics, and features accessed.
          </li>
          <li style={styles.li}>
            <strong>Transaction Information:</strong> Record details regarding
            premium digital subscriptions or content unlocked. All financial
            transactions are handled completely and securely via the Google Play
            Billing API; we do not collect, process, or store your payment card
            or bank account details on our servers.
          </li>
          <li style={styles.li}>
            <strong>Device and Technical Information:</strong> IP address,
            device type, operating system version, and unique device identifiers
            necessary for crash reporting and service security.
          </li>
        </ul>

        <h2 style={styles.h2}>2. How We Use Your Information</h2>
        <p style={styles.p}>
          We use the collected data for the following essential and legitimate
          processing purposes:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            To provide, maintain, and optimize the App's gameplay, core systems,
            and competitive leaderboards.
          </li>
          <li style={styles.li}>
            To manage user accounts, keep track of milestones, and process
            standard in-app premium subscriptions.
          </li>
          <li style={styles.li}>
            To deliver automated customer support responses and send critical
            account, performance, or security updates.
          </li>
          <li style={styles.li}>
            To detect, prevent, and mitigate fraud, technical issues, or
            platform abuse.
          </li>
        </ul>

        <h2 style={styles.h2}>3. Sharing and Disclosure of Information</h2>
        <p style={styles.p}>
          We do not sell, rent, or trade your personal information. We may share
          your relevant information with third parties strictly under the
          following controlled scenarios:
        </p>
        <ul style={styles.ul}>
          <li style={styles.li}>
            <strong>Service Providers:</strong> Trusted third-party vendors and
            partners that assist us with secure database hosting, identity
            verification/authentication, and basic technical application
            analytics.
          </li>
          <li style={styles.li}>
            <strong>Legal and Regulatory Authorities:</strong> Only when
            required to do so by applicable laws, legal subpoenas, or valid
            regulatory and governmental processes.
          </li>
        </ul>

        <h2 style={styles.h2}>4. Data Security</h2>
        <p style={styles.p}>
          The security of your personal data is vital to us. We implement and
          maintain industry-standard physical, technical, and organizational
          measures engineered to protect your personal information against
          unauthorized access, structural alteration, accidental disclosure, or
          destruction.
        </p>

        <h2 style={styles.h2}>5. Your Rights</h2>
        <p style={styles.p}>
          Depending on your geographical jurisdiction, you hold concrete rights
          over your data. At any time, you may request to access the personal
          information we hold about you, request the correction of any
          inaccurate data, or request the total deletion of your profile account
          and all associated metrics.
        </p>

        <h2 style={styles.h2}>6. Children's Privacy</h2>
        <p style={styles.p}>
          The App is not intended for, marketed to, or directed at individuals
          under the age of 18. We do not knowingly or intentionally collect
          personal information from anyone under the age of 18. If we identify
          that a minor has submitted personal info, we will take immediate
          measures to remove it from our systems.
        </p>

        <h2 style={styles.h2}>7. Changes to This Privacy Policy</h2>
        <p style={styles.p}>
          We may update our Privacy Policy periodically to reflect shifts in
          operational or legal frameworks. Any changes will be announced by
          updating the "Effective Date" at the top of this document. We strongly
          recommend checking this page regularly.
        </p>

        <div style={styles.contactBox}>
          <h2 style={{ ...styles.h2, marginTop: 0, borderBottom: "none" }}>
            8. Contact Us
          </h2>
          <p style={styles.p}>
            If you have any remaining questions, feedback, or data privacy
            requests concerning this Privacy Policy, please reach out directly
            to our dedicated support team:
          </p>
          <p style={{ ...styles.p, marginBottom: 0, marginTop: "10px" }}>
            <strong>Email Support:</strong>{" "}
            <a href="mailto:dev@onlyryan.com" style={styles.link}>
              dev@onlyryan.com
            </a>
          </p>
        </div>

        {/* <div style={styles.footer}>
          &copy; {new Date().getFullYear()} OnlyRyan. All Rights Reserved.
        </div> */}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
